import { render, staticRenderFns } from "./FourOhFour.vue?vue&type=template&id=7b4263ab&scoped=true&"
import script from "./FourOhFour.vue?vue&type=script&lang=js&"
export * from "./FourOhFour.vue?vue&type=script&lang=js&"
import style0 from "./FourOhFour.vue?vue&type=style&index=0&id=7b4263ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4263ab",
  null
  
)

export default component.exports